import React, { useState, useRef } from "react";
import Select from "react-select";
import { Grid } from "@mui/material";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoIosPrint } from "react-icons/io";
import { Icon } from "@iconify/react";
import style from "../../../LatestPages/AddNewCustomer.module.css";
import { selectStyle } from "utils/helpers";
import "./Filter.css";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

const AdminFilters = ({
  allProducts,
  handlefilter,
  bulkprint,
  searchInput,
  setSearchInput,
  view,
  setView,
  printList,
  generatePdf,
  generatePreview
}) => {

  const componentRef = useRef(null); // Ensure ref is assigned properly

  const handlePrint = useReactToPrint({
    content: () => componentRef.current, // Properly reference the component
    documentTitle: "Employee Report",
  });


  const [isOpen, setIsOpen] = useState(false);

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const navigate = useNavigate();

  // Initial state for filters
  const [filterValues, setFilterValues] = useState({
    // RfidCode: [],
    // ItemCode: [],
    CategoryId: [],
    ProductId: [],
    DesignId: [],
    FromDate: "",
    ToDate: "",
  });

  const allItems = allProducts || [];

  // Helper function to get unique options
  const getUniqueOptions = (items, key, labelKey) => {
    const unique = new Map();
    items.forEach((item) => {
      const value = item[key];
      const label = item[labelKey];
      if (value && label) {
        if (!unique.has(value)) {
          unique.set(value, { value, label });
        }
      }
    });
    return Array.from(unique.values());
  };

  const filters = [
    // {
    //   key: "RFIDCode",
    //   placeholder: "Rfid Code",
    //   type: "dropdown",
    //   options: getUniqueOptions(allItems, "RFIDCode", "RFIDCode"),
    // },
    // {
    //   key: "ItemCode",
    //   placeholder: "Item Code",
    //   type: "dropdown",
    //   options: getUniqueOptions(allItems, "ItemCode", "ItemCode"),
    // },
    {
      key: "CategoryId",
      placeholder: "Category Name",
      type: "dropdown",
      options: getUniqueOptions(allItems, "CategoryId", "CategoryName"),
    },
    {
      key: "ProductId",
      placeholder: "Product Name",
      type: "dropdown",
      options: getUniqueOptions(allItems, "ProductId", "ProductName"),
    },
    {
      key: "DesignId",
      placeholder: "Design Name",
      type: "dropdown",
      options: getUniqueOptions(allItems, "DesignId", "DesignName"),
    },
    {
      key: "FromDate",
      placeholder: "From Date",
      type: "date",
    },
    {
      key: "ToDate",
      placeholder: "To Date",
      type: "date",
    },
    {
      key: "Print",
      placeholder: "To Date",
      type: "print",
    },
  ];

  const handleFilterChange = (key, value) => {
    const updatedFilterValues = { ...filterValues, [key]: value };
    setFilterValues(updatedFilterValues);

    // Apply filtering logic
    const filteredItems = allItems.filter((item) => {
      return filters.every((filter) => {
        if (
          filter.type === "dropdown" &&
          updatedFilterValues[filter.key]?.length
        ) {
          return updatedFilterValues[filter.key].some(
            (selected) => selected.value === item[filter.key]
          );
        }
        if (filter.type === "date" && updatedFilterValues[filter.key]) {
          const itemDate = new Date(item[filter.key]);
          const selectedDate = new Date(updatedFilterValues[filter.key]);
          return itemDate >= selectedDate;
        }
        return true;
      });
    });

    // Pass filtered data to the parent
    handlefilter(filteredItems);
  };

  const filteredItems = allItems.filter((item) => {
    return filters.every((filter) => {
      if (filter.type === "dropdown" && filterValues[filter.key]?.length) {
        return filterValues[filter.key].some(
          (selected) => selected.value === item[filter.key]
        );
      }
      if (filter.type === "date" && filterValues[filter.key]) {
        const itemDate = new Date(item[filter.key]);
        const selectedDate = new Date(filterValues[filter.key]);
        return itemDate >= selectedDate;
      }
      return true;
    });
  });

  const handleNew = () => {
    navigate("/add_bulk_stock_new");
  };

  console.log('isOpen', isOpen);
  

  const handleViewChange = (selectedView) => {
    setView(selectedView);
    setIsOpen(false); // Close dropdown after selection
    console.log(`Switched to ${selectedView} view`);
  };

  console.log('view' , view);
  

  return (
    <div
      style={{ padding: "10px 0px" }}
      className="adminAllProductsFilterLabelBoxLL"
      ref={componentRef} 
    >
      {/* <div className="adminAllProductsFilterLabel"> */}
      {filters.map((filter, index) => (
        <div className="filter-box">
          {filter.type === "date" ? (
            <input
              type="date"
              style={{ width: "100%", height: "37px", margin: "0px" }}
              placeholder={filter.placeholder}
              value={filterValues[filter.key]}
              onChange={(e) => handleFilterChange(filter.key, e.target.value)}
            />
          ) : filter.type === "print" ? (
            <div
              className="white-spaceLL"
              // style={{
              //   display: "flex",
              //   gap: "10px",
              //   justifyContent: "space-between",
              // }}
            >
              <div  onClick={() => setIsOpen(!isOpen)} className="dropdown-containerLL">
                <button
                  className="dropdown-button"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {view === "List" ? (
                    <>
                      <Icon
                        id="List"
                        icon="material-symbols:view-list"
                        className="dropdown-icon"
                      />
                      List
                    </>
                  ) : (
                    <>
                      <Icon
                        id="Grid"
                        icon="material-symbols-light:grid-view-rounded"
                        className="dropdown-icon"
                      />
                      Grid
                    </>
                  )}
                </button>
                {
                  isOpen && (
                    <div className="dropdown-menu">
                    <button
                      className="dropdown-item"
                      onClick={() => handleViewChange("Grid")}
                    >
                      <Icon
                        icon="material-symbols-light:grid-view-rounded"
                        className="dropdown-icon"
                      />{" "}
                      Grid View
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => handleViewChange("List")}
                    >
                      <Icon
                        icon="material-symbols:view-list"
                        className="dropdown-icon"
                      />{" "}
                      List View
                    </button>
                  </div>
                  )
                }
               
              </div>
              <div className={style["search-container"]}>
                <input
                  type="text"
                  value={searchInput}
                  onChange={handleSearchChange}
                  placeholder="Search..."
                  className={style["serach-input"]}
                />
                <button
                  style={{ margin: 0 }}
                  className={style["search-btn"]}
                  // onClick={handleSearchSubmit}
                >
                  <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                </button>
              </div>
              <Icon
              onClick={()=> generatePdf()}
                style={{
                  fontSize: "35px ",
                  color: "#0077d4",
                  cursor: "pointer",
                }}
                icon="bx:export"
              />
              <button onClick={printList} className={style["custom-btn"]}>
                <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
                Print
              </button>
              <button onClick={bulkprint} className={style["custom-btn"]} type="button">
                <Icon
                  // onClick={handleNew}
                  type="button"
                  onClick={()=>navigate("/add_stock_labelled_unlabelled")}
                  icon="tabler:plus"
                  width="24"
                  height="24"
                />
                New
              </button>
            </div>
          ) : (
            <Select
              isMulti
              isClearable
              closeMenuOnSelect={false}
              placeholder={filter.placeholder}
              value={filterValues[filter.key]}
              options={filter.options || []}
              onChange={(selectedOptions) =>
                handleFilterChange(filter.key, selectedOptions)
              }
              styles={{
                container: (base) => ({ ...base, width: "100%" }),
                control: (base) => ({
                  ...base,
                  minHeight: "35px", // Decreases the height of the input
                  height: "30px", // Ensures the height is consistent
                  fontSize: "12px",
                }),

                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected
                    ? "blue"
                    : state.isFocused
                    ? "lightblue"
                    : "white",
                  color: state.isSelected ? "white" : "black",
                  padding: "6px",
                  fontSize: "12px",
                }),
                singleValue: (base) => ({
                  ...base,
                  fontSize: "14px", // Adjusts the font size of the selected value
                  padding: "2px 2px 2px 0px", // Decreases padding inside the input box
                }),
                menu: (provided) => ({
                  ...provided,
                  borderRadius: "8px",
                  marginTop: "5px",
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  padding: "4px",
                  svg: {
                    width: "12px",
                    height: "12px",
                  },
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  padding: "0px",
                }),
              }}
              // styles={selectStyle}
            />
          )}
        </div>
      ))}
      {/* </div> */}
    </div>
  );
};

export default AdminFilters;
